import React, { MutableRefObject } from 'react';

import { ReceiveRegisterOrderInfo } from './ReceiveRegisterOrderInfo';

import type { TypeReceiveRequestOrder } from '~/types/receive.types';

import styles from './ReceiveRegisterSecondStepContent.module.scss';

type TypeReceiveRegisterSecondStepContentProps = {
  /** 입고 예정 정보 데이터 배열 */
  ordersData: TypeReceiveRequestOrder[];
  /** 공급사 코드 */
  supplierCode: string;
  /** 에러 필드 DOM 참조 객체 */
  errorFieldRefs: MutableRefObject<Record<string, HTMLElement | null>>;
};

/**
 * [입고관리][입고요청관리] 입고요청등록 모달 > 입고 예정 정보 입력 단계 (STEP 2) 컴포넌트
 */
const ReceiveRegisterSecondStepContent = ({
  ordersData,
  supplierCode,
  errorFieldRefs,
}: TypeReceiveRegisterSecondStepContentProps) => {
  return (
    <div className={styles['contents-container']}>
      {ordersData.map((order, index) => {
        return (
          <ReceiveRegisterOrderInfo
            key={order.id}
            orderData={order}
            totalOrderCount={ordersData.length}
            index={index}
            supplierCode={supplierCode}
            errorFieldRefs={errorFieldRefs}
          />
        );
      })}
    </div>
  );
};

export default ReceiveRegisterSecondStepContent;
